function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import { Controls } from 'shared/helper/form';
import { persistPayment, save, saveFailed, updateFormData, updatePaymentCurrencies } from 'researcher/payment/actions';
import { defaultValues as addressDefaultValues } from 'researcher/payment/components/AddressForm';
import { defaultValues as fapiaoDefaultValues } from 'researcher/payment/components/FapiaoForm';
import PaymentMethodSelection from 'researcher/payment/components/PaymentMethodSelection';
import { defaultValues as purchaseOrderDefaultValues } from 'researcher/payment/components/PurchaseOrderForm';
var Form = Controls.Form;
var defaultValues = {
  acceptedTermsAndConditions: false,
  additionalData: {},
  amount: 0,
  billingAddress: addressDefaultValues,
  creditsApplied: 0,
  fapiao: fapiaoDefaultValues,
  fapiaoRequirementConfirmed: '',
  invoiceAddress: addressDefaultValues,
  invoiceAddressDiffersFromBilling: false,
  paymentMethodId: '',
  prepaymentApplied: 0,
  prepaymentOption: '',
  purchaseOrder: purchaseOrderDefaultValues,
  receiptCode: '',
  requireFapiao: false,
  useCredits: 'yes',
  voucherApplied: null
};
var RubriqPaymentForm = function RubriqPaymentForm(_ref) {
  var additionalData = _ref.additionalData,
    buttonTitle = _ref.buttonTitle,
    children = _ref.children,
    excludePaymentMethods = _ref.excludePaymentMethods,
    formRef = _ref.formRef,
    orderIdentity = _ref.orderIdentity,
    paymentsEndpoint = _ref.paymentsEndpoint,
    receiptCode = _ref.receiptCode,
    total = _ref.total;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var dispatch = useDispatch();
  var _methods$watch = methods.watch(['paymentMethodId']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    paymentMethodId = _methods$watch2[0];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var setPaymentMethod = function setPaymentMethod(paymentMethod) {
    if (!paymentMethod) {
      methods.resetField('paymentMethodId');
      return;
    }
    methods.setValue('paymentMethodId', paymentMethod.id);
  };
  var handlePersistPayment = function handlePersistPayment(endpoint, orderIdentity, data) {
    dispatch(save());
    dispatch(persistPayment(endpoint, orderIdentity, data)).catch(function (err) {
      return dispatch(saveFailed(err));
    });
  };
  var resetVoucher = function resetVoucher() {
    return ['voucherApplied', 'prepaymentOption'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  var resetPrepayment = function resetPrepayment() {
    return ['prepaymentApplied', 'prepaymentOption'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  var resetCredits = function resetCredits() {
    return ['creditsApplied', 'useCredits'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  useEffect(function () {
    dispatch(updateFormData({
      paymentMethodId: paymentMethodId
    }));
  }, [paymentMethodId]);
  useEffect(function () {
    methods.setValue('additionalData', additionalData);
    methods.setValue('amount', total);
    methods.setValue('receiptCode', receiptCode);
    dispatch(updatePaymentCurrencies());
    return function () {
      dispatch(updateFormData(defaultValues));
      resetPrepayment();
      resetCredits();
      resetVoucher();
      methods.resetField('paymentMethodId');
    };
  }, []);
  useEffect(function () {
    methods.setValue('additionalData', additionalData);
  }, [JSON.stringify(additionalData)]);
  useEffect(function () {
    methods.setValue('receiptCode', receiptCode);
  }, [receiptCode]);
  useEffect(function () {
    methods.setValue('amount', total);
  }, [total]);
  return /*#__PURE__*/React.createElement(Form, {
    className: "payment-form ms-3",
    methods: methods,
    formRef: formRef,
    onSubmit: function onSubmit(data) {
      return handlePersistPayment(paymentsEndpoint, orderIdentity, data);
    },
    testAttribute: "payment-form"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment details"
  })), total <= 0 ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-info"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "paid-order-notice",
    params: {
      buttonTitle: t(buttonTitle)
    }
  })) : null, /*#__PURE__*/React.createElement(PaymentMethodSelection, {
    excludePaymentMethods: excludePaymentMethods,
    fapiaoSelectionDisabled: false,
    setPaymentMethod: setPaymentMethod,
    total: total
  }), children);
};
export default RubriqPaymentForm;